import { useNavigate } from 'react-router-dom';
import useIsLoggedIn from '../../Hooks/useIsLoggedIn';
import useTranslate from '../../Hooks/useTranslate';
import Button from '../../Style-guide/Button';
import Carousel from '../../Style-guide/Carousel';
import Modal from '../../Style-guide/Modal';
import Text from '../../Style-guide/Text';
import Title from '../../Style-guide/Title';
import TabView from '../TabView';
import CourtInfo from './courtInfo';
import CourtPreviewWrapper from './style/courtPreviewWrapper';

const CourtPreview = ({ show, onClose, data }) => {
  const isLoggedIn = useIsLoggedIn();
  const navigate = useNavigate();
  const tr = useTranslate();

  const { name: courtName, id: courtId } = data || {};

  const images = [data?.mainImage, data?.galleryImage1, data?.galleryImage2].filter(
    Boolean
  );
  const hasImages = images.length > 0;

  const handleReserveClick = () => {
    if (!isLoggedIn) {
      navigate('/signin', { state: { redirectPath: `/reserve-court/${courtId}` } });
      onClose();

      return;
    }
    navigate(`/reserve-court/${courtId}`);
    onClose();
  };

  return (
    <CourtPreviewWrapper>
      <Modal className='court-preview-modal' show={show} onClose={onClose}>
        <Title size='LG' className='court-name overflow-ellipsis'>
          {courtName}
        </Title>
        {hasImages ? (
          <Carousel className='carousel-container' images={images} />
        ) : (
          <div className='no-court-image' />
        )}

        {isLoggedIn ? (
          <TabView
            tabs={[
              {
                id: 'overview',
                label: tr('overview'),
                content: (
                  <address className='court-description'>
                    <Text size='MD'>{data?.description}</Text>
                  </address>
                ),
              },
              {
                id: 'information',
                label: tr('information'),
                content: <CourtInfo court={data} />,
              },
            ].filter(Boolean)}
            defaultTab='overview'
          />
        ) : (
          <Text size='MD' className='login-to-view-info'>
            {tr('signin_to_see_more')}
          </Text>
        )}

        <footer className='button-container'>
          <Button className='reserve-button' onClick={handleReserveClick}>
            {tr('reserve')}
          </Button>
        </footer>
      </Modal>
    </CourtPreviewWrapper>
  );
};

export default CourtPreview;
